/******************************************************************************************
 *	Breadcrumbs Menu
 *******************************************************************************************
 *
 * Service that managed breadcrumbs menu items.
 *
 */
(function() {
  

  //Wrapper class for each breadcrumbs item
  function BreadcrumbItem(label, stateName, stateParams) {
    this.label = label;
    this.stateName = stateName;
    this.stateParams = stateParams;
  }
  //Returns a string from the stateParams as a list of comma-separated key-value pairs
  BreadcrumbItem.prototype.getStateParamsAsString = function() {
    if (!this.stateParams) {
      return '';
    }

    return JSON.stringify(this.stateParams);
  };
  //Returns a string formated for use in a ui-sref directive, e.g. someStateName({someParam:value})
  BreadcrumbItem.prototype.getUiSrefString = function() {
    return this.stateName + '(' + this.getStateParamsAsString() + ')';
  };

  angular.module('rcServices.breadcrumbsMenu', []).service('BreadcrumbsMenu', function(_) {
    var items = [];

    //Returns all breadcrumb items
    this.get = function() {
      return items;
    };

    //Clears the breadcrumb items array and creates a new one
    this.set = function(data) {
      this.clear();

      data = data || [];

      if (presistentItems) {
        data = presistentItems.concat(data);
      }

      var count = data.length;
      for (var i = 0; i < count; i++) {
        this.add(data[i].label, data[i].stateName, data[i].stateParams);
      }
    };

    //If the stateName is unique inside the items array, adds a new entry to it.
    //Otherwise, it just updates the label and stateParams
    this.add = function(label, stateName, stateParams, atIndex) {
      stateName = stateName || null;
      stateParams = stateParams || null;

      //Breadcrumb items have unique stateNames.
      //If a stateName already exists, just update the label and stateParams.
      var count = items.length;
      for (var i = 0; i < count; i++) {
        if (items[i].stateName && items[i].stateName === stateName) {
          items[i].label = label;
          items[i].stateParams = stateParams;
          return;
        }
      }

      //If no `atIndex` is specified append the new item
      if (!atIndex && atIndex !== 0) {
        atIndex = items.length;
      }

      //Otherwise push a new item
      items.splice(atIndex, 0, new BreadcrumbItem(label, stateName, stateParams));
    };

    //Remove item from list by stateName
    this.removeByStateName = function(stateName) {
      items = _.reject(items, ['stateName', stateName]);
    };

    //Updates stateParams for the passed-in stateName
    this.updateStateParams = function(stateName, stateParams) {
      var count = items.length;
      for (var i = 0; i < count; i++) {
        if (items[i].stateName === stateName) {
          items[i].stateParams = stateParams;
          return;
        }
      }
    };

    //Clears the items array
    this.clear = function() {
      items.length = 0;
    };

    //Set and clear methods for items that should always be first in the list,
    //regardless of data passed to set() method
    //This is used in the ResellerImpersonatorController to set the impersonated org name as the first item
    //and in the LicenseAdminSearchController to clear it
    var presistentItems;
    this.setPersistentItems = function(data) {
      if (_.isArray(data)) {
        presistentItems = data;

        //Add add items
        var self = this;
        _.forEach(data, function(item, index) {
          self.add(item.label, item.stateName, item.stateParams, index);
        });
      }
    };
    this.clearPersistentItems = function() {
      if (_.isArray(presistentItems)) {
        //Remove items
        _.forEach(presistentItems, item => {
          this.removeByStateName(item.stateName);
        });
      }

      presistentItems = null;
    };
  });
})();
